import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerAdmin } from "../api";

export default function Register() {
  const [loginValue, setLoginValue] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await registerAdmin({ login: loginValue, password });
      navigate("/login");
    } catch (err) {
      console.error(err);
      setError("Registration failed. Try another login.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="so-register-page">
      {/* Scoped SwiftOrder theme — fonts, tokens and ticket styling,
          same tokens as Login.js so both pages match exactly. */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Inter:wght@400;500;600;700;800&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

        .so-register-page {
          --ink: #1c1a17;
          --paper: #fbf9f4;
          --paper-dim: #f2ede1;
          --chili: #e4572e;
          --chili-dark: #c43f1a;
          --herb: #3f6b4f;
          --mustard: #f2a93b;
          --stone: #6b6459;
          --stone-light: #a49c8d;
          --line: #ddd4c2;
          --font-display: 'Bebas Neue', 'Arial Narrow', sans-serif;
          --font-body: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          --font-mono: 'JetBrains Mono', 'Courier New', monospace;

          min-height: 100vh;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 24px;
          background: var(--paper);
          background-image: radial-gradient(circle at 1px 1px, var(--line) 1px, transparent 1.6px);
          background-size: 26px 26px;
          font-family: var(--font-body);
          color: var(--ink);
        }

        .so-register-page * {
          box-sizing: border-box;
        }

        .so-register-brand {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-bottom: 22px;
        }

        .so-register-brand-mark {
          font-family: var(--font-mono);
          font-weight: 700;
          font-size: 0.8rem;
          background: var(--ink);
          color: var(--paper);
          width: 34px;
          height: 34px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 4px;
        }

        .so-register-brand-name {
          font-family: var(--font-display);
          font-size: 1.6rem;
          letter-spacing: 0.02em;
        }

        .so-register-brand-accent {
          color: var(--chili);
        }

        .so-register-card-wrap {
          width: 100%;
          max-width: 420px;
        }

        .so-register-card {
          position: relative;
          background: #fffdf8;
          border: 1px solid var(--line);
          border-radius: 10px;
          padding: 34px 32px 26px;
          box-shadow: 0 18px 40px -14px rgba(28, 26, 23, 0.35);
        }

        .so-register-card::after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: -1px;
          height: 14px;
          background-image: radial-gradient(circle, var(--paper) 5px, transparent 5.5px);
          background-size: 20px 14px;
          background-repeat: repeat-x;
          background-position: -2px 0;
        }

        .so-register-eyebrow {
          font-family: var(--font-mono);
          font-size: 0.7rem;
          letter-spacing: 0.14em;
          text-transform: uppercase;
          color: var(--chili);
          font-weight: 600;
          display: inline-flex;
          align-items: center;
          gap: 8px;
        }

        .so-register-eyebrow::before {
          content: "";
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: var(--chili);
        }

        .so-register-title {
          font-family: var(--font-display);
          font-size: 2rem;
          letter-spacing: 0.01em;
          margin: 10px 0 24px;
        }

        .so-field {
          display: flex;
          flex-direction: column;
          gap: 6px;
          margin-bottom: 16px;
        }

        .so-field label {
          font-size: 0.78rem;
          font-weight: 700;
          font-family: var(--font-mono);
          letter-spacing: 0.04em;
          color: var(--stone);
        }

        .so-field input {
          border: 1px solid var(--line);
          border-radius: 6px;
          padding: 12px 14px;
          font-size: 0.95rem;
          font-family: var(--font-body);
          background: var(--paper);
          color: var(--ink);
          outline: none;
          transition: border-color 0.15s ease, box-shadow 0.15s ease;
        }

        .so-field input:focus {
          border-color: var(--chili);
          box-shadow: 0 0 0 3px rgba(228, 87, 46, 0.15);
        }

        .so-register-error {
          text-align: center;
          font-size: 0.85rem;
          color: var(--chili-dark);
          background: #fdece6;
          border: 1px solid var(--chili);
          border-radius: 6px;
          padding: 10px 14px;
          margin-bottom: 16px;
        }

        .so-submit-btn {
          width: 100%;
          background: var(--chili);
          color: var(--paper);
          border: none;
          border-radius: 6px;
          padding: 13px 0;
          font-weight: 700;
          font-size: 0.95rem;
          cursor: pointer;
          box-shadow: 0 10px 24px -10px rgba(228, 87, 46, 0.6);
          transition: background 0.15s ease, transform 0.1s ease, opacity 0.15s ease;
        }

        .so-submit-btn:hover:not(:disabled) {
          background: var(--chili-dark);
        }

        .so-submit-btn:active:not(:disabled) {
          transform: translateY(1px);
        }

        .so-submit-btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

        .so-login-block {
          text-align: center;
          padding-top: 18px;
          margin-top: 20px;
          border-top: 1px dashed var(--line);
        }

        .so-login-text {
          font-size: 0.88rem;
          color: var(--stone);
        }

        .so-login-link {
          display: inline-block;
          margin-top: 8px;
          font-weight: 700;
          font-size: 0.9rem;
          color: var(--chili);
          background: none;
          border: none;
          cursor: pointer;
          padding: 0;
        }

        .so-login-link:hover {
          color: var(--chili-dark);
          text-decoration: underline;
        }
      `}</style>

      <div className="so-register-card-wrap">
        <div className="so-register-brand">
          <span className="so-register-brand-mark">SO</span>
          <span className="so-register-brand-name">
            Swift<span className="so-register-brand-accent">Order</span>
          </span>
        </div>

        <div className="so-register-card">
          <span className="so-register-eyebrow">Get started</span>
          <h1 className="so-register-title">Register Admin</h1>

          <form onSubmit={handleSubmit}>
            <div className="so-field">
              <label>Login</label>
              <input
                type="text"
                value={loginValue}
                onChange={(e) => setLoginValue(e.target.value)}
                required
              />
            </div>

            <div className="so-field">
              <label>Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            {error && <p className="so-register-error">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="so-submit-btn"
            >
              {loading ? "Registering..." : "Register Admin"}
            </button>
          </form>

          <div className="so-login-block">
            <p className="so-login-text">Already have account?</p>
            <button
              type="button"
              className="so-login-link"
              onClick={() => navigate("/login")}
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}









// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { registerAdmin } from "../api";

// export default function Register() {
//   const [loginValue, setLoginValue] = useState("");
//   const [password, setPassword] = useState("");
//   const [error, setError] = useState("");
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError("");
//     setLoading(true);
//     try {
//       await registerAdmin({ login: loginValue, password });
//       navigate("/login");
//     } catch (err) {
//       console.error(err);
//       setError("Registration failed. Try another login.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-slate-100">
//       <div className="bg-white shadow-lg rounded-xl p-8 w-full max-w-md">
//         <h1 className="text-2xl font-bold mb-4 text-center">Register Admin</h1>
//         <form onSubmit={handleSubmit} className="space-y-4">
//           <div>
//             <label className="block mb-1 text-sm font-medium">Login</label>
//             <input
//               type="text"
//               className="w-full border rounded px-3 py-2"
//               value={loginValue}
//               onChange={(e) => setLoginValue(e.target.value)}
//               required
//             />
//           </div>
//           <div>
//             <label className="block mb-1 text-sm font-medium">Password</label>
//             <input
//               type="password"
//               className="w-full border rounded px-3 py-2"
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               required
//             />
//           </div>
//           {error && <p className="text-red-500 text-sm">{error}</p>}
//           <button
//             type="submit"
//             disabled={loading}
//             className="w-full bg-emerald-600 text-white py-2 rounded hover:bg-emerald-700"
//           >
//             {loading ? "Registering..." : "Register Admin"}
//           </button>
//         </form>

//         <p className="mt-4 text-center text-sm">
//           Already have account?{" "}
//           <button
//             className="text-blue-600 underline"
//             onClick={() => navigate("/login")}
//           >
//             Login
//           </button>
//         </p>
//       </div>
//     </div>
//   );
// }
